import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { Layout, Menu, Card, Statistic, Row, Col, Pagination, Drawer, Button } from 'antd';
import TestBox from './TestBox';
import {SERVER_PATH, axiosConfig1 } from '../actions/common';
import axios from 'axios';
import { setCbt } from '../actions/cbt';
import { useParams } from 'react-router';
import TestContent from './TestContent';

const { Header, Content, Footer } = Layout;

const { Countdown } = Statistic;
const deadline = Date.now() + 1000 * 60 * 60 * 24 * 2 + 1000 * 30; // Moment is also OK

const Test = (props) => {
    const {id} = useParams()
    const tagr = useRef()
    const [answer_pool, setanswer_pool] = useState({})
    const [noq, setnoq] = useState(0)
    const [isloading, setisloading] = useState(false)
    const [duration, setduration] = useState(0)


    const cdate = Date.now()
    
    useEffect(() => {
     
      let test_all = props.test_data || {}
      let test = test_all[id] || {}
      let duration = test['testtime'] || 0
      let noq = test['noq'] || 0
     console.log(test_all, id)
      setduration(parseInt(duration))
      setnoq(parseInt(noq))
      
    }, [id])

    const SubmitTest = (answer, answers, noq) =>{
      let targ = tagr.current.props.value
      let correct = []
      Object
      .keys(answers)
      .forEach(element => {
        let wrg = answers[element]
         if(typeof answer === 'object' && 
         answer.hasOwnProperty(element) &&
         answer[element] === wrg ){
            correct.push(element)
         }else{

         }
      });
    
      let correct_score  = correct.length > 0 ? correct.length/noq : 0

      const cdate1 = Date.now()
      let mins = (targ - cdate1) / ( 60 * 1000 )
      let fd = new FormData();
            fd.append('answer', JSON.stringify(answer));
            fd.append('score', correct_score);
            fd.append('status', 1);
            fd.append('duration', mins);
            fd.append('id', id);
            fd.append('cat', 'cbtsave');
            fd.append('table', 'cbttests');  
            setisloading(true)
            axios
            .post(SERVER_PATH, fd, axiosConfig1)
            .then(res => {
                  setisloading(false)
                  let arr = {}
                  arr['testid'] = res.data.data.testid
                  arr['data'] = res.data.data
                  setCbt(arr)
                  //window.close()
            })
            .catch(err => {
                    setisloading(false)
            })
    }

    const PauseTest = (answer) =>{
      let targ = tagr.current.props.value
      const cdate1 = Date.now()
      let mins = (targ - cdate1) / ( 60 * 1000 )
      let fd = new FormData();
            fd.append('answer', JSON.stringify(answer));
            fd.append('duration', mins);
            fd.append('status', 2);
            fd.append('id', id);
            fd.append('cat', 'cbtsave');
            fd.append('table', 'cbttests');  
            setisloading(true)
            axios
            .post(SERVER_PATH, fd, axiosConfig1)
            .then(res => {
                  setisloading(false)
                  if(parseInt(res.data.data.testid) > 0){
                    let arr = {}
                    arr['testid'] = res.data.data.testid
                    arr['data'] = res.data.data 
                    setCbt(arr)
                   // window.close()
                }
            })
            .catch(err => {
                    setisloading(false)
            })
    }
   
   let dura = cdate  + duration * 60 * 1000

  return (
    <Layout style={{minHeight:'200px'}}>
    <Header style={{ position: 'fixed', zIndex: 1, width: '100%' }}>
      <div className="logo" />
      <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['2']}>
        <Menu.Item key="1">Test Platform</Menu.Item>
        <Menu.Item key="2">nav 2</Menu.Item>
      </Menu>
      
    </Header>
    <Content className="site-layout text-left" style={{ padding: '0 50px', marginTop: 64 }}>
      <div className="site-layout-background" style={{ padding: 24, minHeight: 380 }}>
      <Card>
          <Row gutter={16}>
                <Col xs={12} span={24}>
                <Countdown 
                    ref={tagr}
                    title="" 
                    value={dura} 
                    format="HH:mm:ss:SSS" 
                    />
                </Col>
          </Row>
      </Card>
      <TestContent
        id={id}
        submit = {(e, f, g)=>SubmitTest(e, f, g)}
        pause = {(e)=>PauseTest(e)}
      />
     
      </div>
    </Content>
    <Footer 
      style={{  
        position:'sticky',
        left:'0', 
        buttom:'0', 
        zIndex: 1, 
        width: '100%' ,
        backgroundColor:'red'
      }}
    >
    </Footer>
   
  </Layout>
  )
}

const mapStateToProps = (state) => ({
  test_data :state.cbtReducer.cbtTests
})

const mapDispatchToProps = {setCbt}

export default connect(mapStateToProps, mapDispatchToProps)(Test)